import { render, staticRenderFns } from "./FormCreate.vue?vue&type=template&id=24b75c18"
import script from "./FormCreate.vue?vue&type=script&lang=js"
export * from "./FormCreate.vue?vue&type=script&lang=js"
import style0 from "./FormCreate.vue?vue&type=style&index=0&id=24b75c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports